import { objToQs } from '../../Utils';
import Call from "../../Call.v2";

const Arbitrage = {
    get(filters) {
        return Call(`ad_content/arbitrage?${objToQs(filters)}`);
    },
    values(filters, column) {
        return Call(`ad_content/arbitrage/${column}?${objToQs(filters)}`);
    },
    keywords(filters) {
        return Call(`ad_content/arbitrageKeywords?${objToQs(filters)}`);
    },
    cron: {
        start(date) {
            return Call(`ad_content/arbitrage/cron/start?date=${date}`, 'POST');
        },
        status() {
            return Call(`ad_content/arbitrage/cron/status`);
        }
    }

};

export default Arbitrage;



// WEBPACK FOOTER //
// ./src/services/API/components/AdContent/Arbitrage.js